import { Cabin } from '@fcom/dapi/api/models';

export enum FlightTimeOption {
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
  EVENING = 'EVENING',
}

export interface FlightFilters {
  departureTime?: FlightTimeOption[];
  arrivalTime?: FlightTimeOption[];
  refundable?: boolean;
  cabin?: Cabin;
  maxStops?: number | null;
}

export const defaultFilterValues = {
  defaultStopsOption: null,
  defaultRefundabilityOption: false,
  defaultTravelClass: Cabin.MIXED,
  defaultTimeOptions: [...Object.values(FlightTimeOption)],
};

export const FAKE_LOAD_TIME = 300;
